import N8nChatInput from './ChatInput.vue';

export { useChatInputAutoFocus } from './useChatInputAutoFocus';
export type {
	ChatInputAutoFocusOptions,
	ChatInputAutoFocusTarget,
} from './useChatInputAutoFocus';

export default N8nChatInput;
